import { Integer, Text, Float, Bool } from 'lib/validate';
import { modules } from './CampaignConstraints';

const theme = {
    'settings.theme.primary': { color: true },
    'settings.theme.secondary': { color: true },
    'settings.theme.background': { color: true }
};
const font = {
    'settings.font.color': { color: true },
    'settings.font.size': Integer({ min: 12, max: 18 }),
    'settings.font.family': Text({ required: false }),
    'settings.font.custom': Bool()
};
const checkout_button = {
    'settings.modules.checkout_button.button_text.text': Text({ max: 50, min: 3, name: 'text' }),
    'settings.modules.checkout_button.button_text.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.button_text.color': { color: true },
    'settings.modules.checkout_button.button_text_loading.text': Text({
        max: 20,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.button_text_loading.color': { color: true },
    'settings.modules.checkout_button.background': { color: true },
    // 'settings.modules.checkout_button.hoverBackground': { color: true },
    'settings.modules.checkout_button.coupon.background': { color: true },
    // 'settings.modules.checkout_button.coupon.hoverBackground': { color: true },
    'settings.modules.checkout_button.use_coupon_code.text': Text({
        max: 40,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.use_coupon_code.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.use_coupon_code.color': { color: true },
    'settings.modules.checkout_button.enter_coupon_code.text': Text({
        max: 40,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.enter_coupon_code.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.enter_coupon_code.color': { color: true },
    'settings.modules.checkout_button.apply_coupon_code.text': Text({
        max: 15,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.apply_coupon_code.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.apply_coupon_code.color': { color: true },
    'settings.modules.checkout_button.edit_coupon_code.text': Text({
        max: 35,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.edit_coupon_code.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.close_coupon_code.text': Text({
        max: 35,
        min: 3,
        name: 'text'
    }),
    'settings.modules.checkout_button.close_coupon_code.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.subtotal.text': Text({ max: 35, min: 3, name: 'text' }),
    'settings.modules.checkout_button.subtotal.font_size': Float({
        min: 0.5,
        max: 2,
        name: 'font size'
    }),
    'settings.modules.checkout_button.subtotal.color': { color: true }
};

const header = {
    'settings.header.title.text': Text({ max: 35, min: 3 }),
    'settings.header.title.font_size': Float({ max: 2, min: 0.5, name: 'cart title font size' }),
    'settings.header.title.color': { color: true },
    'settings.header.background': { color: true }
};

const product = {
    'settings.product.title.text': Text({ max: 35, min: 3, name: 'text' }),
    'settings.product.title.font_size': Float({ max: 2, min: 0.5, name: 'font size' }),
    'settings.product.title.color': { color: true },
    'settings.product.price.text': Text({ max: 35, min: 3, name: 'text' }),
    'settings.product.price.font_size': Float({ max: 2, min: 0.5, name: 'font size' }),
    'settings.product.sold_out': Text({ name: 'sold out' }),
    'settings.product.price.color': { color: true },
    'settings.product.image_size': Integer({ min: 50, max: 120, name: 'product image size' })
};

// const product_details = {
// 	'settings.product_details.atcButton.text': Text({ max: 35, min: 3, name: 'text' }),
// 	'settings.product_details.atcButton.font_size': Float({ max: 2, min: 0.5, name: 'font size' }),
// 	'settings.product_details.atcButton.color': { color: true },
// 	'settings.product_details.readMore.text': Text({ max: 35, min: 3, name: 'text' }),
// 	'settings.product_details.readMore.font_size': Float({ max: 2, min: 0.5, name: 'font size' }),
// 	'settings.product_details.readMore.color': { color: true },
// 	'settings.product_details.truncate_length': Integer({ min: 50, max: 500, name: 'description length' }),
// 	'settings.product_details.truncate': Bool(),
// 	'settings.product_details.atcButton_background': { color: true },
// 	'settings.product_details.atcButton_hoverBackground': { color: true },
// };

const settings = {
    'settings.multiCurrencyMode': Bool(),
    'settings.empty_cart': Text(),
    ...theme,
    ...font,
    ...{ ...modules, ...checkout_button },
    ...header,
    ...product
    // ...product_details,
};

const ShopConstraints = {
    ...settings
};

export default ShopConstraints;
